window.RS = window.RS || {};
window.RS.GoogleTracking = (function() {
  const GoogleTracking = {};

  // Add additional GA4 events here. Convention is to match the event name defined
  // in GA4.
  GoogleTracking.events = {
    GA4_ADD_TO_CART: 'ga4:add_to_cart', // Appending ga4: to event name to prevent conflict with existing tag & trigger with add_to_cart event
    GA4_PURCHASE: 'ga4:purchase' // Appending ga4: to event name to prevent conflict with existing tag & trigger with purchase event
  };

  GoogleTracking.getCart = () => {
    return new Promise((resolve, reject) => {
      fetch('/cart.js')
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          return {}
        }
      })
      .then(data => {
        if (data.success == false) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  }

  GoogleTracking.dispatchGa4AddToCartTrack = (lineItem) => {
    if (lineItem) {
      var gaAddToCart = new CustomEvent(GoogleTracking.events.GA4_ADD_TO_CART, {
        detail: {
          lineItem: lineItem
        }
      });
  
      document.dispatchEvent(gaAddToCart);
    }
  };

  GoogleTracking.onGa4AddToCart = async (e) => {    
    const item = e && e.detail && e.detail.lineItem;
    let products = [];

    if (item) {
      const dataLayer = window.dataLayer || [];
      let cart = await GoogleTracking.getCart().catch(e => { console.log('Cart Fetch Error: ', e) }) || {};

      products.push({
        item_id: `${item.sku || item.variant_id || item.product_id}`,
        item_name: item.product_title || '',
        discount: (item.line_level_total_discount || 0) / 100.00,
        item_brand: item.vendor || '',
        item_category: item.product_type || '',
        item_variant: item.variant_title || item.title || '',
        price: item.final_price / 100.00,
        quantity: item.quantity
      });

      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'ga4:add_to_cart',
        ecommerce: {
          currency: cart.currency || 'USD',
          value: item.final_line_price / 100.00,
          items: products
        }
      });
    }
  }

  GoogleTracking.registerEvents = () => {
    document.addEventListener(GoogleTracking.events.GA4_ADD_TO_CART, GoogleTracking.onGa4AddToCart);
  }

  return GoogleTracking;
})();
window.RS.GoogleTracking.registerEvents();